<h2 mat-dialog-title>{{ header }}</h2>
<mat-dialog-content class="mat-typography">
	<h3>{{ content }}</h3>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close>Ok</button>
</mat-dialog-actions>